import { render, staticRenderFns } from "./SessionExpired.vue?vue&type=template&id=b25ae966&scoped=true"
import script from "./SessionExpired.vue?vue&type=script&lang=js"
export * from "./SessionExpired.vue?vue&type=script&lang=js"
import style0 from "./SessionExpired.vue?vue&type=style&index=0&id=b25ae966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25ae966",
  null
  
)

export default component.exports